import React, { useState } from 'react'
import FeedbackPopup from '#src/components/FeedbackPopup'
import { Experiment, Variation } from '@deal/experiment-js'
import styles from './styles.css'
import { DepartmentIcon } from '@deal/components'
import classnames from 'classnames'

interface FeedbackProps {
  slug?: string
  showTopBorder?: boolean
  showBottomBorder?: boolean
  feedbackClassName?: string
  sourceKey: Tracking.FeedbackSourceKey
}

const Feedback: React.FC<FeedbackProps> = ({
  slug = 'curated-internal',
  showTopBorder,
  showBottomBorder,
  feedbackClassName,
  sourceKey
}) => {
  const [feedbackOpen, setFeedbackOpen] = useState(false)
  return (
    <Experiment id="feedback-popup" default="off">
      <Variation id="on">
        {showTopBorder && <div className={styles.border} />}
        <div className={classnames(styles.feedbackContainer, feedbackClassName)}>
          <DepartmentIcon departmentSlug={slug} />
          <div className={styles.feedbackText}>
            How's your Curated experience going?{' '}
            <div className={styles.feedbackLink} onClick={() => setFeedbackOpen(true)}>
              Give us feedback
            </div>
          </div>
        </div>
        {showBottomBorder && <div className={styles.border} />}
        {feedbackOpen && (
          <FeedbackPopup
            isOpen={feedbackOpen}
            onRequestClose={() => setFeedbackOpen(false)}
            sourceKey={sourceKey}
          />
        )}
      </Variation>
      <Variation id="off" />
    </Experiment>
  )
}

export default Feedback
